<template>
  <div class="demo-collapse">
    <el-collapse v-model="activeNames">
      <el-collapse-item 
        v-for="(classInfo, index) in showList"
        :key="'node' + index"
        :title="classInfo.name"
        :name="'node' + index" >
        <div class="red-ui-palette-node-group" v-for="(listItem, listIndex) in classInfo.list" :key="'list' + listIndex">
          <div
            class="red-ui-palette-node ui-draggable ui-draggable-handle"
            @mousedown="startDrag(listItem)"
            :style="{ backgroundColor: listItem.background , width: listItem.width, height: listItem.height}"
          >
            <div class="red-ui-palette-label">{{listItem.text}}</div>
            <div class="red-ui-palette-icon-container">
              <div class="red-ui-palette-icon" :style="{ backgroundImage: `url(${listItem.icon})`}"></div>
            </div>
            <div class="red-ui-palette-port red-ui-palette-port-input"></div>
            <div class="red-ui-palette-port red-ui-palette-port-output"></div>
          </div>
          <!-- <a v-if="listItem.url" :href="listItem.url">
            <i class="el-icon-question" style="color:#aaa;font-size: 22px" title="查看服务详情"></i>
          </a> -->
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import LogicFlow from '@qiov/logicflow-core'
import menu1 from '@/assets/img/editor/menu1.png'
import menu2 from '@/assets/img/editor/menu2.png'
import menu3 from '@/assets/img/editor/menu3.png'
import eventBus from "@/utils/eventBus";

export default {
  name: 'Palette',
  props: {
    lf: {
      type: LogicFlow,
      required: true
    }
  },
  data() {
    return {
      serviceClass1: menu1,
      serviceClass2: menu2,
      serviceClass3: menu3,
      showIndex: [],
      activeNames: ['node0'],
      nodeList: [
        {
          name: '外灯',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'lowBeam-node',
              text: '近光灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/LowBeam.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr1'
              }
            },
            {
              type: 'HighBeam-node',
              text: '远光灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/HighBeam.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr1'
              }
            },
            {
              type: 'BrakeLight-node',
              text: '制动灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/BrakeLight.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            },
            {
              type: 'CorneringLamp-node',
              text: '转向灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/CorneringLamp.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1,
                  "turnLightType": "Left",
                  "isFlow": false,
                  "isLoop": false,
                  "onTime": 0,
                  "offTime": 0,
                },
                attribute: 'attr4'
              }
            },
            {
              type: 'DayLight-node',
              text: '日间行车灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/DayLight.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            },
            {
              type: 'AfterFogLamps-node',
              text: '后雾灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/AfterFogLamps.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            },
            {
              type: 'BackLight-node',
              text: '倒车灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/BackLight.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            },
            {
              type: 'PositionLamp-node',
              text: '位置灯控制',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/PositionLamp.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1,
                  "turnLightType": "Left"
                },
                attribute: 'attr3'
              }
            },
            {
              type: 'HeadlightHeight-node',
              text: '大灯高度调节',
              background: 'rgb(240, 230, 225)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/HeadlightHeight.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "bigLightHight": "Middle"
                },
                attribute: 'attr5'
              }
            }
          ],
        },
        {
          name: '外后视镜',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'RearviewMirror-node',
              text: '外后视镜折叠控制',
              background: 'rgb(230, 232, 245)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/RearViewMirror.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr6'
              }
            },
            {
              type: 'RearviewMirrorDefrosting-node',
              text: '外后视镜加热',
              background: 'rgb(230, 232, 245)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/RearviewMirrorDefrosting.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            }
          ]
        },
        {
          name: '喇叭',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'Horn-node',
              text: '喇叭控制',
              background: 'rgb(244, 232, 242)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Horn.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr: {
                  "operateType": 1,
                  "isLoop": false,
                  "onTime": 0,
                  "offTime": 0
                },
                attribute: 'attr9'
              }
            }
          ]
        },
        {
          name: '车窗',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'DoorWindow-node',
              text: '车窗控制',
              background: 'rgb(227, 228, 193)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/DoorWindow.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr: {
                  "operateTypeBeforL": 1,
                  "operateTypeBeforR": 1,
                  "operateTypeAfterL": 1,
                  "operateTypeAfterR": 1,
                  "stepLengthBeforL": 1,
                  "stepLengthBeforR": 1,
                  "stepLengthAfterL": 1,
                  "stepLengthAfterR": 1
                },
                attribute: 'attr7'
              }
            },
            {
              type: 'WindowMistForward-node',
              text: '前风挡除雾',
              background: 'rgb(227, 228, 193)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/WindowMistForward.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            },
            {
              type: 'WindowMistBack-node',
              text: '后风挡除雾',
              background: 'rgb(227, 228, 193)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/WindowMistBack.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            }
          ]
        },
        {
          name: '钥匙',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'Key-node',
              text: '遥控钥匙命令',
              background: 'rgb(189, 193, 226)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Key.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "keyBtn": "Lock"
                },
                attribute: 'attr11'
              }
            }
          ]
        },
        {
          name: '雨刮',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'Wiper-node',
              text: '前雨刮控制',
              background: 'rgb(220, 208, 228)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Wiper.svg',
              width: '160px',
              height: '30px',
              properties: {
                attribute: 'attr10'
              }
            }
          ]
        },
        {
          name: '车门',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'Door-node',
              text: '电车门控制',
              background: 'rgb(253, 245, 216)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Door.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr: {
                  "operateTypeBeforL": 1,
                  "operateTypeBeforR": 1,
                  "operateTypeAfterL": 1,
                  "operateTypeAfterR": 1
                },
                attribute: 'attr8'
              }
            }
          ]
        },
        {
          name: '电动尾门',
          img: '@/assets/img/editor/menu1.png',
          list: [
            {
              type: 'RearDoor-node',
              text: '电动尾门控制',
              background: 'rgb(254, 236, 212)',
              icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/RearDoor.svg',
              width: '160px',
              height: '30px',
              properties: {
                operateStr : {
                  "operateType": 1
                },
                attribute: 'attr2'
              }
            }
          ]
        },
        // {
        //   name: '环境监控',
        //   img: '@/assets/img/editor/menu1.png',
        //   list: [
        //     {
        //       type: 'Rain-node',
        //       text: '雨量信息',
        //       background: 'rgb(135, 206, 234)',
        //       icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Rain.svg',
        //       width: '160px',
        //       height: '30px',
        //       properties: {
        //         operateStr : {
        //           "operateType": 1
        //         }
        //       }
        //     },
        //     {
        //       type: 'Temperature-node',
        //       text: '环境温度信息',
        //       background: 'rgb(135, 206, 234)',
        //       icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Temperature.svg',
        //       width: '160px',
        //       height: '30px',
        //       properties: {
        //         operateStr : {
        //           "operateType": 1
        //         }
        //       }
        //     },
        //     {
        //       type: 'Humidity-node',
        //       text: '环境湿度信息',
        //       background: 'rgb(135, 206, 234)',
        //       icon: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Humidity.svg',
        //       width: '160px',
        //       height: '30px',
        //       properties: {
        //         operateStr : {
        //           "operateType": 1
        //         }
        //       }
        //     }
        //   ]
        // },
        {
          name: '其他',
          img: '@/assets/img/editor/menu1.png',
          list: [{
            type: 'delay-node',
            text: '延时控制',
            background: 'rgb(226, 228, 233)',
            icon: '/images/delay.svg',
            width: '160px',
            height: '30px',
            properties: {
              operateStr : {
                "operateType": 0
              },
              attribute: 'attr12'
            },
            url: 'https://www.baidu.com'
          }]
        }
      ],
      showList: []
    }
  },
  created() {
    this.searchKeyword()
    this.showList = this.nodeList
  },
  methods: {
    startDrag(item) {
      item.properties.name = item.text
      this.lf.dnd.startDrag({
        type: item.type,
        text: item.text,
        properties: item.properties
      })
    },
    clickUL(index) {
      if (this.showIndex.indexOf(index) === -1) {
        this.showIndex.push(index)
      }
      else {
        this.showIndex.splice(this.showIndex.indexOf(index), 1)
      }
    },
    searchKeyword() {
      eventBus.$on('keyword', (keyword) => {
        this.showList = JSON.parse(JSON.stringify(this.nodeList))
        if (keyword === '') {
          this.showIndex = []
        }
        else {
          this.activeNames = []
          for (let i = 0; i < this.showList.length; i++) {
            this.querySearch(keyword, this.showList[i].list, i)
          }
        }
      })
    },
    querySearch(queryString, item, i) {
      const res = item
      // console.log(this.createFilter(queryString))
      const results = res.filter(this.createFilter(queryString))
      // console.log(results)
      if (results.length > 0) {
        if (this.showIndex.indexOf(i) === -1) {
          this.showIndex.push(i)
          this.activeNames.push('node' + i)
        }
        this.showList[i].list = results
      }
      else {
        this.showList[i].list = []
      }
    },
    createFilter(queryString) {
      return (param) => {
        return (param.text.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
      }
    },
    _stopPropagation(ev) {
      ev.stopPropagation()
    }
  }
}
</script>
<style scoped>
.demo-collapse {
  width: 260px;
  overflow-y: auto;
  height: calc(100vh - 175px);
  /* background-color: #FFFFFF; */
  /* background-color: #f6f5f5; */
  background-color: #fafafa;
}
.demo-collapse /deep/ .el-collapse-item__header {
  text-indent: 20px;
  font-size: 16px;
  /* background-color: #f6f5f5; */
  background-color: #fafafa;
  border-bottom: 1px solid #d8dadf;
}
.demo-collapse li {
  height: 40px;
}
.red-ui-palette-node {
  cursor: move;
  background: #fff;
  margin: 10px 20px;
  height: 25px;
  border-radius: 5px;
  border: 1px solid #999;
  background-position: 5% 50%;
  background-repeat: no-repeat;
  width: 120px;
  background-size: contain;
  position: relative;
}
.red-ui-palette-node:hover {
  border: 2px solid #ff7f0e;
}
.red-ui-palette-label {
  color: #333;
  font-size: 12px;
  margin-left: 32px;
  line-height: 30px;
  overflow: hidden;
  text-align: center;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.red-ui-palette-icon-container {
  position: absolute;
  text-align: center;
  top: 0;
  bottom: 0;
  left: 0;
  width: 30px;
  border-right: 1px solid rgba(0,0,0,.05);
  background-color: rgba(0,0,0,.05);
}
.red-ui-palette-icon {
  display: inline-block;
  width: 20px;
  height: 100%;
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}
.red-ui-palette-port-input {
  left: auto;
  right: -6px;
}
.red-ui-palette-port {
  position: absolute;
  top: 10px;
  left: -5px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  background: #d9d9d9;
  border-radius: 3px;
  width: 10px;
  height: 10px;
  border: 1px solid #999;
}
.red-ui-palette-port-output {
  left: auto;
  right: -6px;
}
.red-ui-palette-node-group {
  display: flex;
  align-items: center;
  list-style-type:none;
  height: 40px;
}
/deep/ .el-collapse-item__content {
  padding: 10px 0;
}
/deep/ .el-collapse-item__arrow {
  width: 20px;
  height: 20px;
  text-indent: initial;
}
</style>
